import React from 'react';
import { Box, Button, CardContent } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { PremiumInfoQuery } from '../../../../schema';
import { PropertiesTable, PropertiesTableRow } from '../../../../ui/PropertiesTable';
import { useStyles } from '../useStyles';

type Props = {
  data: PremiumInfoQuery | undefined;
};

export const PremiumInfoCard = ({ data }: Props) => {
  const classes = useStyles();
  const premiumInfo = data?.premiumInfo;

  return (
    <CardContent className={classes.content}>
      {premiumInfo?.backgroundImage?.url && (
        <Box className={classes.imageContainer}>
          <img
            src={premiumInfo.backgroundImage.url}
            alt="Premium background"
            className={classes.backgroundImage}
          />
        </Box>
      )}

      <PropertiesTable>
        <PropertiesTableRow caption="Заголовок блока" value={premiumInfo?.title} />
        <PropertiesTableRow caption="Описание" value={premiumInfo?.description} />
        <PropertiesTableRow caption="Текст кнопки" value={premiumInfo?.buttonText} />
        <PropertiesTableRow caption="Код действия кнопки" value={premiumInfo?.buttonActionCode} />
      </PropertiesTable>

      <Box className={classes.buttonContainer}>
        <Button
          color="primary"
          variant="contained"
          component={Link}
          to="/battle-pass/premium-access/edit"
        >
          Редактировать
        </Button>
      </Box>
    </CardContent>
  );
};
